export { default } from './GradientIcon';
export type { GradientIconProps } from './GradientIcon';
